import React from 'react';
import PropTypes from 'prop-types';
import HoverMenu from './hover-menu/hover-menu';
import HoverMenuItem from './hover-menu/hover-menu-item';
import { getMenuGaAttributes } from './site-header.analytics.js';
import { useTranslator } from 'tradera-lang';

import HeartIcon from '@tradera/blueprint/theme/icons2/heart.svg?jsx';
import BookmarkIcon from '@tradera/blueprint/theme/icons2/bookmark.svg?jsx';
import StarIcon from '@tradera/blueprint/theme/icons2/star.svg?jsx';

const getGaAttributes = label =>
    getMenuGaAttributes('Top navigation', 'Watchlist menu', label);

const WatchListMenu = ({ showMenu }) => {
    const { t } = useTranslator();
    return (
        <HoverMenu showMenu={showMenu}>
            <HoverMenuItem
                label={t('siteHeader_wishlist')}
                link="/my/wish-list"
                icon={<HeartIcon className="icon" />}
                gaAttributes={getGaAttributes('Wishlist')}
            />
            <HoverMenuItem
                label={t('siteHeader_savedSearches')}
                link="/my/saved-searches"
                icon={<BookmarkIcon className="icon" />}
                gaAttributes={getGaAttributes('Saved searches')}
            />
            <HoverMenuItem
                label={t('siteHeader_favouriteSellers')}
                link="/my/favourite-sellers"
                icon={<StarIcon className="icon" />}
                gaAttributes={getGaAttributes('Favorite seller')}
            />
        </HoverMenu>
    );
};

WatchListMenu.propTypes = {
    showMenu: PropTypes.bool
};

export default WatchListMenu;
